'use strict';

var React = require('react'),
    IconMixin = require('../../mixins/IconMixin');

var ImageIcon = React.createClass({
  mixins: [IconMixin],

  renderSVG: function (size) {
    switch (size) {
    case 'small':
      return '<circle cx="12" cy="7" r="2"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M17 15c0 0.55-0.45 1-1 1H2c-0.55 0-1-0.45-1-1V3c0-0.55 0.45-1 1-1h14c0.55 0 1 0.45 1 1V15z"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M1.01 7.99C1.01 6.34 2.35 5 4 5c1.65 0 2.99 1.34 2.99 2.99 0 2.76 2.24 5 5 5s5-2.24 5-5"/>';
    case 'medium':
      return '<circle stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="21.5" cy="12.5" r="3.75"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M31 27.13C31 28.16 30.16 29 29.13 29H2.88C1.84 29 1 28.16 1 27.13V4.88C1 3.84 1.84 3 2.88 3h26.25C30.16 3 31 3.84 31 4.88V27.13z"/><path stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M1.02 14.11c0-3.1 2.51-5.61 5.61-5.61s5.61 2.51 5.61 5.61c0 5.18 4.2 9.38 9.38 9.38s9.38-4.2 9.38-9.37"/>';
    case 'large':
      return '<circle stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" cx="32.5" cy="18.5" r="5.5"/><path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M46.5 40.69c0 1.55-1.26 2.81-2.81 2.81H4.31c-1.55 0-2.81-1.26-2.81-2.81V7.31C1.5 5.76 2.76 4.5 4.31 4.5h39.38c1.55 0 2.81 1.26 2.81 2.81V40.69z"/><path stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M1.52 21.16c0-4.65 3.77-8.41 8.41-8.41s8.41 3.77 8.41 8.41c0 7.77 6.3 14.06 14.06 14.06s14.06-6.3 14.06-14.06"/>';
    }
  }
});

module.exports = ImageIcon;


/** WEBPACK FOOTER **
 ** ./atoms/icons/Image.jsx
 **/